<template>
<div class="distributionViewDialog bgc" v-if="dialogVisible">
    <el-dialog title="分销明细" :visible.sync="dialogVisible" width="800px">
        <div class="title">
            <div class="box">分销员：<img :src="userinfo.headimgurl" alt="" class="img"> <span class="tc-black">{{userinfo.customername}}</span>
            </div>
            <div class="box">联系方式：<span class="tc-black">{{userinfo.mobileno}}</span></div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="title" label="活动名称" min-width="200"></el-table-column>
                <el-table-column prop="datetime" label="订单时间" width="180"></el-table-column>
                <el-table-column prop="finalpaymoney" label="订单金额（元）" width="120">
                    <template slot-scope="scope">￥{{scope.row.finalpaymoney}}</template>
                </el-table-column>
                <el-table-column prop="parentusermoney" label="分销佣金" width="120">
                    <template slot-scope="scope">￥{{scope.row.parentusermoney}}</template>
                </el-table-column>
            </el-table>
            <dialogPage :total="total" @getList="_getList" ref="dialogPage"></dialogPage>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getShareCustomerDetailListByCustomerid} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import DialogPage from 'base/page/dialogPage'

export default {
    name: 'distributionViewDialog',
    data() {
        return {
            param: {
                customerid: '',
                eventid: '',
            },
            dialogVisible: false,
            userinfo: {},
            tableData: [],
            total: 0
        }
    },
    mounted() {
    },
    methods: {
        openDialog(obj) {
            this.param.customerid = obj.sharecustomerinnerid
            this.param.eventid = obj.eventid
            this.tableData = []
            this.total = 0
            let dialogPage = {page: 1, pageSize: this.dialogPage.pageSize}
            this.$store.commit('SET_DIALOGPAGE', dialogPage)
            this._getList()
            this.dialogVisible = true
        },
        _getList() {
            this.setLoading(true)
            getShareCustomerDetailListByCustomerid({
                data: Object.assign({}, this.param, this.dialogPage),
                success: data => {
                    if (this.dialogPage.page == 1) {
                        this.userinfo = data.data.customerinfo
                    }
                    this.total = data.data.pageinfo.rowCount
                    this.tableData = data.data.sharelist
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'dialogPage'
        ])
    },
    components: {
        DialogPage
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.distributionViewDialog {
    .title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        margin-bottom: 20px;
        .box {
            display: flex;
            align-items: center;
            margin-right: 30px;
            .img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
    }
    .imgtext {
        display: flex;
        align-items: center;
        .img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
